import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core';
import type { FeatureCompareModel } from '../feature-compare-model';
import type { FeatureCompareState } from '../../types';
import { ClaimGoogleTransLang, StreamStatus } from '../../types/enum';
import { PARAMS_ID_DEFAULT } from '../../constants';
import { LangTypeMode } from '@/domains/translation/enums';

@injectable()
export class FeatureCompareModelImpl extends AbstractModel<FeatureCompareState> implements FeatureCompareModel {
    private initializeFeatureCompareState(): FeatureCompareState {
        return {
            claimPatentId: '',
            descPatentId: PARAMS_ID_DEFAULT,
            claimLang: '',
            descLang: '',
            compares: [],
            compareStreamStatus: StreamStatus.PROGRESS_INIT,
            claimStreamStatus: StreamStatus.PROGRESS_INIT,
            transLoading: false,
            claimPatentSN: '',
            descPatentSN: '',
            transLang: ClaimGoogleTransLang.DEFAULT,
            transLangType: LangTypeMode.ORIGINAL,
            isIndepFeatureNames: [],
        };
    }
    protected _modelData: FeatureCompareState = this.initializeFeatureCompareState();
    public defaultModelData: FeatureCompareState = this.initializeFeatureCompareState();
}